import { labelRegion } from '../../../features/labels/labels';
import { useLabelVersion } from '../../../features/labels/LabelsProvider';
import { labelId } from '../../../features/labels/labels';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from 'react-simple-maps';
import { geoCentroid } from 'd3-geo';
import Nanoox from '../../../assets/img/APP-nanoox-1 (003).png';
import Pss from '../../../assets/img/APP pss.png';
import Enviro from '../../../assets/img/APP enviro.png';
import Scapp from '../../../assets/img/APP-scapp.png';
import { hover, motion } from 'framer-motion';

// Mapping service keys to their icons
const serviceIcons = {
  enviro: Enviro,
  nanoox: Nanoox,
  pss: Pss,
  scapp: Scapp,
};
const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

const mapConfig = {
  0: { default: { center: [-71.6, -33.4], scale: 5500 } },
  1: {
    loslagos: { center: [-73.2, -42.7], scale: 13000 },
    magallanes: { center: [-71.1, -52.8], scale: 4500 },
    losrios: { center: [-72.65, -40.3], scale: 20000 },
    default: { center: [-73.4, -46.9], scale: 9000 },
  },
  2: {
    default: { center: [-73.5, -44.9], scale: 8500 },
    'loslagos-magallanes': { center: [-72.95, -45.25], scale: 7000 },
    'aysen-loslagos': { center: [-73.3, -44.9], scale: 6500 },
  },
  3: {
    'aysen-loslagos-magallanes': { center: [-72.95, -45.25], scale: 1000 },
    'aysen-loslagos-losrios': { center: [-72.95, -40.25], scale: 1000 },
    default: { center: [-71.29, -48.8], scale: 4500 },
  },
  4: { default: { center: [-71.9, -48.3], scale: 3500 } },
};

function getMapConfig(selectedRegions) {
  const n = selectedRegions.length;
  if (n < 1 || n > 4) return mapConfig[1].default;
  const cfg = mapConfig[n];
  if (n === 1) {
    const key = selectedRegions[0].toLowerCase();
    return cfg[key] || cfg.default;
  }
  if (n === 2) {
    const key = selectedRegions.map(r => r.toLowerCase()).sort().join('-');
    return cfg[key] || cfg.default;
  }
  return cfg.default;
}

const ChileMap = ({ chileGeo, chileRegions, servicios, services, selRegion, setSelRegion, setSelArea, parseRegion, chileRegionMap, handleServiceClick, servicioFiltrado }) => {
  useLabelVersion();

  // console.log('servicioFiltrado',servicioFiltrado)
  // console.log('services',services)

  const [hoveredService, setHoveredService] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [selectedService, setSelectedService] = useState(null);
  const mapRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(1000);

  // cerrar al click fuera
  useEffect(() => {
    const onDocClick = () => setSelectedService(null);
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  // Capturar altura del contenedor para animación
  useEffect(() => {
    if (mapRef.current) {
      const { height } = mapRef.current.getBoundingClientRect();
      setContainerHeight(height);
    }
  }, []);



    // 1. Filtrado por servicio
  const filteredServicios = servicioFiltrado
    ? servicios.filter(({ area, key }) => {
        const regionAreaKey = area
          .split('-')
          .map(capitalize)
          .join('-');
        const centersMap = services[regionAreaKey] || {};
        const matchedCenterKey = Object.keys(centersMap)
          .find(k => k.toLowerCase() === key.toLowerCase());
        return !!(
          matchedCenterKey &&
          centersMap[matchedCenterKey][servicioFiltrado] &&
          centersMap[matchedCenterKey][servicioFiltrado].status_service
        );
      })
    : servicios;


  if (!chileGeo) return <p style={{ fontSize: '1vw' }}>Cargando Chile…</p>;

  const { center: configuredCenter, scale } = getMapConfig(chileRegions);
  const visibleChileFeatures = (chileGeo.features || []).filter(geo => {
    const id = chileRegionMap[geo.properties.codregion];
    return id && chileRegions.includes(id);
  });
  const computedCenter = visibleChileFeatures.length
    ? geoCentroid({ type: 'FeatureCollection', features: visibleChileFeatures })
    : configuredCenter;
  const center = computedCenter.every(Number.isFinite) ? computedCenter : configuredCenter;
  const handleMapClick = () => setSelectedService(null);
  const handleWheel = e => {
    e.preventDefault();
    const delta = -e.deltaY / 500;
    setZoom(z => Math.min(Math.max(z + delta, 1), 10));
  };

  const rawSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6">
    <defs>
      <pattern id="hatchPattern" width="6" height="6" patternUnits="userSpaceOnUse">
        <!-- línea diagonal de esquina a esquina -->
        <line x1="0" y1="6" x2="6" y2="0"
              stroke="#000" stroke-width="1"/>
      </pattern>
    </defs>
    <rect width="6" height="6" fill="url(#hatchPattern)"/>
  </svg>
  `;
  const hatchSvg = encodeURIComponent(rawSvg);
  // Base delay para íconos: tras animación de regiones (n regiones * 0.1s)
  const baseServiceDelay = chileRegions.length * 0.9;

  return (
    <div ref={mapRef} className="map chile-map" style={{ backgroundImage: `url("data:image/svg+xml;utf8,${hatchSvg}")`, backgroundRepeat: 'repeat' }} onClick={handleMapClick} onWheel={handleWheel}>
      <ComposableMap projection="geoMercator" projectionConfig={{ scale }} style={{ width: '100%', height: '100%' }} onClick={handleMapClick}>
        <defs>
          <pattern id="hatchPattern" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="6" stroke="#000" strokeWidth="1" />
          </pattern>
        </defs>
        <ZoomableGroup center={center} zoom={zoom}>
          <Geographies geography={chileGeo}>
            {({ geographies }) => (
              // Renderizar solo cuando tenemos altura
              containerHeight > 0 && geographies.map((geo, index) => {
                const id = chileRegionMap[geo.properties.codregion];
                if (!id || !chileRegions.includes(id)) return null;
                const sel = selRegion === id;
                const rawName = parseRegion(geo);
                const label = rawName.includes('Ays') ? 'Aysén' : rawName.includes('Magall') ? 'Magallanes' : rawName;

                return (
                  <motion.g
                    key={geo.rsmKey}
                    initial={{ opacity: 0, y: -containerHeight }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1, type: 'spring', stiffness: 200, damping: 20 }}
                  >
                    <Geography
                      geography={geo}
                      onClick={e => { e.stopPropagation(); setSelRegion(id); setSelArea(null); }}
                      stroke={sel ? "rgb(233, 78, 26)" : "#c3c3c3"}
                      strokeWidth={0.5}
                      fill={sel ? "url(#hatchPattern)" : '#222'}
                      style={{ default: { outline: 'none' }, hover: { outline: 'none' }, pressed: { outline: 'none' } }}
                    />
                    <Marker coordinates={geoCentroid(geo)}>
                      <motion.text
                        initial={{ opacity: 0, y: -containerHeight }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 + 0.2, type: 'spring', stiffness: 200, damping: 20 }}
                        textAnchor="middle"
                        dy={4}
                        style={{ fill: '#c3c3c3', fontSize: '1.5vw' }}
                      >{labelRegion(id, label)}</motion.text>
                    </Marker>
                  </motion.g>
                );
              })
            )}
          </Geographies>
          {filteredServicios.map(({ area, key, coords }, idx) => {
            const regionAreaKey = area
              .split('-')
              .map(capitalize)
              .join('-');
            const centersMap = services[regionAreaKey] || {};
            const matchedCenterKey = Object.keys(centersMap)
              .find(k => k.toLowerCase() === key.toLowerCase());
            const parts = matchedCenterKey
              ? matchedCenterKey.split('-')
              : [key];
            const [centerName = key] = parts;

            // / 1) Obtener info del servicio filtrado
            let serviceInfo

            if (servicioFiltrado && matchedCenterKey) {
              serviceInfo = centersMap[matchedCenterKey][servicioFiltrado];
            } 
            return (
              <motion.g
                key={key}
                initial={{ opacity: 0, y: -containerHeight }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: baseServiceDelay + idx * 0.1,
                  type: 'spring',
                  stiffness: 200,
                  damping: 20
                }}
                style={{ cursor: 'pointer' }}
                onClick={e => {
                  e.stopPropagation();
                  setSelectedService(s => (s === key ? null : key));
                  setHoveredService(null);
                  
                  handleServiceClick( servicioFiltrado, serviceInfo );
                }}
                onMouseEnter={e => {
                  e.stopPropagation();
                  setHoveredService(key);
                }}
                onMouseLeave={() => setHoveredService(null)}
              >
                <Marker coordinates={[coords.lon, coords.lat]}>
                  <ellipse className="loader-location-shadow" cx={12} cy={40} rx={8} ry={3} pointerEvents="none" />
                  <path
                    className="loader-location-chile"
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                    transform="translate(-10 -2) scale(1)"
                  />
                </Marker>
              </motion.g>
            );
          })}

          { hoveredService && (() => {
            const activeKey =  hoveredService
            const serviceItem = servicios.find(s => s.key === activeKey);
            if (!serviceItem) return null;
            const { coords, area } = serviceItem;
            const regionAreaKey = area.split('-').map(capitalize).join('-');
            const centersMap = services[regionAreaKey] || {};
            const matchedCenterKey = Object.keys(centersMap)
              .find(k => k.toLowerCase() === activeKey.toLowerCase());
            const [centerName] = matchedCenterKey
              ? matchedCenterKey.split('-')
              : [activeKey];
            const iconSize = 35;  


            return (
              <Fragment key={activeKey}>
                <Marker coordinates={[coords.lon, coords.lat]}>
                  <text
                    textAnchor="middle"
                    dy={iconSize + 4}
                    // y={(-iconSize / 2) + 38}
                    y={(-iconSize / 2) - 28}
                    x={(-iconSize / 2) + 30 }
                    style={{ fill: '#c3c3c3', fontSize: '0.7vw',  }}
                  >
                    {labelId(matchedCenterKey, 'car', capitalize(centerName))}
                  </text>
                </Marker>
              </Fragment>
            );
          })()}

        </ZoomableGroup>
      </ComposableMap>

      <style jsx>{`
       
        .info-card-chile {
          height:20vh;
          border-radius: 0.4vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 0.7vw;
          padding: 0.5vw;
          pointer-events: auto;
        }
        .center-name-gps-chile {
          color: #c3c3c3;
          font-size: .5vw;
          margin-top: 6.5vh;
          text-align: center;
          position:absolute
        }
        .coords-chile {
          display: flex;
          justify-content: center;
          color: #c3c3c3;
          font-size: 0.5vw;
          margin-top: 0.2vh;
        }
        .loader-location-chile {
          fill: #e94e1a;
          stroke: #e94e1a;
          stroke-width: 10;
          transform-origin: center bottom;
          animation: animMarker 0.4s ease-in-out infinite alternate;
          cursor: pointer;
        }
        .loader-location-shadow {
          fill: rgba(0, 0, 0, 0.2);
        }
        @keyframes animMarker {
          0% { transform: translateY(0.1vw); }
          100% { transform: translateY(-0.1vw); }
        }
      `}</style>
      
    </div>
  );
};

export default ChileMap;
